<template>
  <v-container>
    <v-dialog
      v-model="showDialog"
      scrollable
      max-width="90%"
      :retain-focus="false"
    >
      <!--<v-skeleton-loader v-if="loading" type="article, actions" />-->
      <v-card>
        <v-card-title style="padding: 5px 0 0 5px">
          <v-col cols="12">
            <span style="font-size: 20px">
              {{ $t("wkt.admin.vacations.calendar-wizard.title") }}
            </span>
            <!--<v-btn icon style="top: -20px; left: 10px; float: right;">
							<v-icon @click="showDialog=false">close</v-icon>
						</v-btn>-->
          </v-col>
        </v-card-title>
        <v-card-text>
          <v-container fluid class="mx-0 pa-4 pb-2" @wheel="onWheel">
            <v-form ref="form">
              <v-row>
                <span
                  style="font-size: 16px; font-weight: bold; color: #424242"
                  >{{ $t("wkt.admin.vacations.calendar-wizard.title_1") }}</span
                >
              </v-row>
              <v-row class="d-flex justify-start py-0">
                <v-col cols="3">
                  <v-autocomplete
                    attach
                    v-model="vacationRecordType"
                    :items="vacationRecordTypes"
                    item-text="text"
                    item-value="value"
                    :label="$t('wkt.admin.vacations.calendar-wizard.record_type')"
                    :rules="[validationRules.required]"
                    class=""
                    allow-overflow
                    style="
                      max-width: 500px;
                      min-width: 100px;
                    "
                  />
                </v-col>
                <v-col cols="3">
                  <v-autocomplete
                    attach
                    v-model="selectedHourBag"
                    :items="hoursBags"
                    item-text="label"
                    item-value="id"
                    :rules="[validationRules.required]"
                    :label="
                      $t('wkt.admin.vacations.calendar-wizard.hour_bag')
                    "
                    class=""
                    allow-overflow
                    style="
                      max-width: 500px;
                      min-width: 100px;
                    "
                  />
                </v-col>
              </v-row>
              <v-row class="d-flex justify-start py-0">
                <v-col cols="3">
                  <v-menu
                    :close-on-content-click="true"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="fromDateFormatted"
                        :label="
                          $t(
                            'wkt.admin.vacations.calendar-wizard.start_date'
                          )
                        "
                        readonly
                        v-on="on"
                        dense
                      />
                    </template>
                    <v-date-picker
                      v-model="fromDateIso"
                      no-title
                      scrollable
                      :first-day-of-week="1"
                      :locale="$i18n.locale"
                    ></v-date-picker>
                  </v-menu>
                </v-col>
                <v-col cols="3" v-if="vacationRecordType === 7 /*Constants.VACATION_RECORD_TYPE_COMPLETE_DAY*/">
                  <v-menu
                    :close-on-content-click="true"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="toDateFormatted"
                        :label="
                          $t(
                            'wkt.admin.vacations.calendar-wizard.end_date'
                          )
                        "
                        readonly
                        v-on="on"
                        v-bind="attrs"
                        dense
                        :error-messages="errorMessages"
                      />
                    </template>
                    <v-date-picker
                      v-model="toDateIso"
                      no-title
                      scrollable
                      :first-day-of-week="1"
                      :locale="$i18n.locale"
                    ></v-date-picker>
                  </v-menu>
                </v-col>
                <v-col cols="3">
                  <v-text-field
                    v-model="vacationDays"
                    :rules="[
                      validationRules.required,
                    ]"
                    :label="
                      $t('wkt.admin.vacations.calendar-wizard.vacation_days')
                    "
                    type="number"
                    class="mt-n4"
                    min="-365"
                    max="365"
                  ></v-text-field>
                </v-col>
                <v-col cols="3" style="display: none">
                  <v-checkbox
                    v-model="allowNegativeBalance"
                    :label="$t('wkt.admin.vacations.calendar-wizard.allow_negative')"
                    class="mt-0 mr-2 text-capitalize"
                    hide-details
                  />
                </v-col>
              </v-row>
              <v-row class="d-flex justify-start py-0">
                <v-col cols="12">
                  <v-text-field
                    v-model="vacationDescription"
                    :label="$t('wkt.admin.vacations.calendar-wizard.description')"
                  />
                </v-col>
              </v-row>
            </v-form>
            <v-row style="margin-top: 10px">
              <span
                style="font-size: 16px; font-weight: bold; color: #424242"
                >{{ $t("wkt.admin.vacations.calendar-wizard.title_2") }}</span
              >
            </v-row>
            <EmployeesManager
              ref="employeeManager"
              :projectType="1"
              :tableLoading="tableLoading"
              :tableHeaders="tableHeaders"
              :tableItems="employees"
              :emptyStateTitle="$t('wkt.admin.teams.team.empty-state.title')"
              :emptyStateDescription="
                $t('wkt.admin.vacations.calendar-wizard.empty-state.description')
              "
              tableHeight="290px"
              @remove-all-employees="confirmRemoveAllProjectEmployees($event)"
              @add-employees="addProjectEmployees()"
              @remove-employee="removeProjectEmployee($event)"
            />
          </v-container>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            text
            @click="onUpdate()"
            style="font-size: 0.9em; font-weight: 400"
            >{{
              $t("wkt.admin.vacations.calendar-wizard.create_record").toUpperCase()
            }}</v-btn
          >
          <v-btn
            text
            @click="close()"
            style="font-size: 0.9em; font-weight: 400"
            >{{
              $t("wkt.admin.common.dialog-buttons.close").toUpperCase()
            }}</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <LoadingDialog :loading="loading" />

    <TargetManagerDialog
      ref="dlgTargetManager"
      :filterByProfile="true"
      :title="$t('wkt.admin.teams.team.add_employees')"
      :targetLabel="$t('wkt.admin.employee-selector-window.target_placeholder')"
    />

    <ConfirmDialog
      ref="dlgConfirmRemoveAllProjectEmployees"
      :title="$t('wkt.admin.teams.team.remove-employees-confirm-dialog.title')"
      :message="confirmMessage"
      :titleOk="$t('wkt.admin.common.dialog-buttons.delete')"
      :titleCancel="$t('wkt.admin.common.dialog-buttons.cancel')"
      @confirmed="removeAllProjectEmployees()"
    />

    <v-dialog v-model="showConfirm" persistent max-width="500" style="z-index:20099;">
          <v-card>
            <v-card-title class="headline">{{ $t('wkt.admin.vacations.calendar-wizard.title') }}</v-card-title>
            <v-card-text>
              <div v-if="conflicts.length>0">
                <p>{{ $t('wkt.admin.vacations.calendar-wizard.conflicts.description') }}</p>
                <ul>
                  <li v-for="item in conflicts" :key="item">{{formatSimpleDate(item.fromDate)}} / {{formatSimpleDate(item.toDate)}} -  {{ item.idNumber?item.idNumber + ' - ':'' }} {{ item.lastname }}, {{ item.firstname }}</li>
                </ul>
                <br><p>{{ $t('wkt.admin.vacations.calendar-wizard.conflicts.description_2') }}</p>
              </div>
              <div v-else>
                <p>{{ $t('wkt.admin.vacations.calendar-wizard.conflicts.description_3') }}</p>
              </div>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" text @click="processVacationAssistant()">{{ $t('wkt.admin.common.dialog-buttons.continue') }}</v-btn>
              <v-btn color="secondary" text @click="showConfirm=false">{{ $t('wkt.admin.common.dialog-buttons.cancel') }}</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

    <v-snackbar v-model="showAlert" :timeout="alertTimeout" :color="alertColor">
      <span style="color: #ffffff">{{ alertText }}</span>
      <v-btn text @click="showAlert = false">
        <span style="color: #ffffff">{{
          $t("wkt.admin.common.dialog-buttons.close")
        }}</span>
      </v-btn>
    </v-snackbar>
  </v-container>
</template>

<script>
import BaseModule from "../../common/BaseModule.js";
import EmployeesManager from "../../common/EmployeesManager.vue";
import LoadingDialog from "../../common/LoadingDialog.vue";
import TargetManagerDialog from "../dialogs/TargetManagerDialog.vue";
import ConfirmDialog from "../../common/ConfirmDialog.vue";
import api from "../../../api/worktime.js";
import gwt from "../../../api/gwt.js";
import { getHoursBags } from "../../common/VacationUtils.js";
import CommonFormatter from "../../common/CommonFormatter.js";

export default {
  name: "VacationAssistantDialog",
  mixins: [BaseModule, CommonFormatter],
  components: {
    EmployeesManager,
    TargetManagerDialog,
    ConfirmDialog,
    LoadingDialog,
  },
  data() {
    return {
      loading: false,
      fromDateFormatted: null,
      fromDateIso: null,
      toDateFormatted: null,
      toDateIso: null,
      allowNegativeBalance: false,
      vacationDays: 1,
      showConfirm: false,
      conflicts: [],
      data: {},
      items: [],
      headers: [],
      departments: [],
      employees: [],
      selectedHourBag: 6, /*Constants.HOURS_BAG_VACATION_ID*/
      hoursBags: [],
      tableLoading: false,
      tableHeaders: [],
      managers: [],
      managerIds: [],
      workplaces: [],
      errorMessages: "",
      showAlert: false,
      alertColor: "error",
      alertText: "",
      alertTimeout: 3000,
      showDialog: false,
      availableEmployees: [],
      confirmMessage: "",
      vacationDescription: "",
      vacationRecordType: 7, /*Constants.VACATION_RECORD_TYPE_COMPLETE_DAY*/
      vacationRecordTypes: [
        { value: 1 /*Constants.VACATION_RECORD_TYPE_REGULARIZATION*/, text: this.$t("wkt.admin.holidays.calendar.edit-holiday-window.new-record-window.types.regularization") },
        { value: 2 /*Constants.VACATION_RECORD_TYPE_WORK_ACCRUED*/, text: this.$t("wkt.admin.holidays.calendar.edit-holiday-window.new-record-window.types.work_accrued") },
        { value: 7 /*Constants.VACATION_RECORD_TYPE_COMPLETE_DAY*/, text: this.$t("wkt.admin.holidays.calendar.edit-holiday-window.new-record-window.types.complete_day") },
        { value: 8 /*Constants.VACATION_RECORD_TYPE_FOR_HOURS*/, text: this.$t("wkt.admin.holidays.calendar.edit-holiday-window.new-record-window.types.for_hours") }
      ],
    };
  },
  computed: {},
  methods: {
    onWheel(event) {
      event.stopPropagation();
    },
    // eslint-disable-next-line no-unused-vars
    onReveal(action, payload) {
      this.items = [];
      this.departments = [];
      this.errorMessages = "";
      this.projects = this.getProjects();
      this.workplaces = this.getWorkplaces();
      this.vacationDescription = "";
      this.showDialog = true;

      if (this.$refs.form) {
        this.$refs.form.resetValidation();
      }

      const company = gwt.getSessionInformation().company;
      let hoursBags = getHoursBags(company);
      this.hoursBags = hoursBags.filter((hoursBag) => hoursBag.enabled);

      this.headers = [
        {
          text: this.$t("wkt.admin.projects.calendar-wizard.periodicity_days"),
          value: "periodicityInDays",
          sortable: false,
        },
        {
          text: this.$t("wkt.admin.projects.calendar-wizard.project_title"),
          value: "project",
          sortable: false,
        },
        {
          text: this.$t("wkt.admin.projects.calendar-wizard.calendar_title"),
          value: "calendar",
          sortable: false,
        },
        {
          text: this.$t("wkt.admin.projects.calendar-wizard.workplace_title"),
          value: "workplace",
          sortable: false,
        },
        {
          text: this.$t("wkt.admin.projects.calendar-wizard.company-notes"),
          value: "notes",
          sortable: false,
        },
        { text: "", value: "actions", sortable: false, width: "200px" },
      ];

      this.tableHeaders = [
        {
          text: this.$t("wkt.admin.projects.project.table.headers.name"),
          value: "firstname",
          width: "25%",
          sortable: false,
        },
        {
          text: this.$t("wkt.admin.projects.project.table.headers.id_number"),
          value: "idNumber",
          width: "15%",
          sortable: false,
        },
        {
          text: this.$t("wkt.admin.projects.project.table.headers.workplace"),
          value: "workplaceName",
          width: "20%",
          sortable: false,
        },
        {
          text: this.$t("wkt.admin.projects.project.table.headers.department"),
          value: "departmentName",
          width: "20%",
          sortable: false,
        },
        { text: '', value: 'removeAction', width: '15%', sortable: false },
      ];

      const today = new Date();
      const tomorrow = new Date(today);
      tomorrow.setDate(today.getDate() + 1);
      const year = tomorrow.getFullYear();
      const month = String(tomorrow.getMonth() + 1).padStart(2, "0");
      const day = String(tomorrow.getDate()).padStart(2, "0");

      this.fromDateIso = `${year}-${month}-${day}`;
      this.toDateIso = `${year}-${month}-${day}`;

      this.fromDateFormatted = this.formatISOStringDateToLocalDate(
        this.fromDateIso
      );
      this.toDateFormatted = this.formatISOStringDateToLocalDate(
        this.toDateIso
      );
      this.getDepartments();
    },
    getDepartments() {
      this.loading = true;
      if (gwt.getDepartments()) {
        this.departments = gwt.getDepartments();
        this.getAllManagers();
        this.loading = false;
        return;
      }

      api.getStaff(
        (data) => {
          this.loading = false;
          this.departments = data;
          this.getAllManagers();
        },
        (error) => {
          this.loading = false;
          this.doShowAlert({
            text: error.message,
            color: "error",
            timeout: 3000,
          });
        }
      );
    },
    getAllManagers() {
      this.managers = [];

      for (let i = 0; i < this.departments.length; i++) {
        this.managers = [...this.managers, ...this.departments[i].employees];
      }

      this.managers.sort((a, b) => {
        const fullnameA = this.getEmployeeFullname(a).toLowerCase();
        const fullnameB = this.getEmployeeFullname(b).toLowerCase();
        if (fullnameA == fullnameB) return 0;
        if (fullnameA > fullnameB) return 1;
        return -1;
      });
    },
    getWorkplaces() {
      this.loading = true;
      api.getWorkPlaces(
        (data) => {
          this.loading = false;
          this.workplaces = data;
          const noModifyWorkplace = {
            id: -1,
            name: this.$t(
              "wkt.admin.projects.calendar-wizard.no-modify-workplace"
            ),
          };
          const resetWorkplace = {
            id: -2,
            name: this.$t("wkt.admin.projects.calendar-wizard.reset-workplace"),
          };
          this.workplaces.unshift(noModifyWorkplace, resetWorkplace);
        },
        (error) => {
          this.loading = false;
          this.doShowAlert({
            text: error.message,
            color: "error",
            timeout: 3000,
          });
        }
      );
    },

    validate() {
      this.errorMessages = "";

      if (!this.$refs.form.validate()) {
        return;
      }

      if (this.fromDateIso && this.toDateIso) {
        const dtStart = new Date(this.fromDateIso).getTime();
        const dtEnd = new Date(this.toDateIso).getTime();

        if (dtStart > dtEnd) {
          this.errorMessages = this.$t(
            "wkt.admin.holidays.calendar.edit-holiday-window.new-record-window.errors.end_date_smaller"
          );
          return false;
        }
      }

      if (this.employees.length <= 0) {
        this.doShowAlert({
          text: this.$t(
            "wkt.admin.projects.calendar-wizard.not_selected_employees"
          ),
          color: "error",
          timeout: 3000,
        });
        return false;
      }
      return true;
    },
    addProjectEmployees() {
      const employeesByDepartment = this.departments.flatMap(
        (department) => department.employees
      );

      this.$refs.dlgTargetManager.open(
        employeesByDepartment,
        this.data.id,
        (selectedEmployeeIds) => {
          const alreadyAddedEmployeeIds = this.employees.map((e) => e.id);
          const newEmployeeIds = selectedEmployeeIds.filter(
            (id) => !alreadyAddedEmployeeIds.includes(id)
          );

          // if (newEmployeeIds.length === 0) {
          //   return;
          // }

          const updatedEmployees = [...this.employees];

          const workplaceIds = [
            ...new Set(
              newEmployeeIds
                .map(
                  (id) =>
                    employeesByDepartment.find((e) => e.id === id)?.workplaceId
                )
                .filter(Boolean)
            ),
          ];
          const departmentIds = [
            ...new Set(
              newEmployeeIds
                .map(
                  (id) =>
                    employeesByDepartment.find((e) => e.id === id)?.departmentId
                )
                .filter(Boolean)
            ),
          ];

          const workplaceNamesMap = {};
          workplaceIds.forEach((id) => {
            workplaceNamesMap[id] = this.getWorkplaceNameById(id);
          });

          const departmentNamesMap = {};
          departmentIds.forEach((id) => {
            departmentNamesMap[id] = this.getDepartmentNameById(id);
          });

          newEmployeeIds.forEach((id) => {
            const employee = employeesByDepartment.find((e) => e.id === id);
            if (employee) {
              updatedEmployees.push({
                ...employee,
                projectId: null,
                workplaceName: workplaceNamesMap[employee.workplaceId],
                departmentName: departmentNamesMap[employee.departmentId]
              });
            }
          });
          this.employees = updatedEmployees;
          this.tableLoading = false;

          // let me = this;
          // this.$nextTick(() => {
          //   me.scrollTo();
          // });

          let message = this.$t(
            "wkt.admin.projects.project.num_employees_added"
          );
          message = message.replace("%d", `${newEmployeeIds.length}`);
          this.doShowAlert({ text: message, color: "success", timeout: 3000 });
        }
      );
    },
    removeProjectEmployee(employeeId) {
      this.employees = this.employees.filter((e) => e.id !== employeeId);
    },
    confirmRemoveAllProjectEmployees() {
      const numEmployeesToRemove = this.employees.length;
      this.confirmMessage = this.$t(
        "wkt.admin.projects.project.remove-employees-confirm-dialog.text"
      );
      this.confirmMessage = this.confirmMessage.replace(
        "%d",
        `${numEmployeesToRemove}`
      );

      this.$refs.dlgConfirmRemoveAllProjectEmployees.confirm();
    },
    removeAllProjectEmployees() {
      this.employees = [];
    },
    getProjects() {
      this.loading = true;
      api.getProjects(
        (res) => {
          this.loading = false;
          this.projects = res.filter((project) => project.projectType === 0);
          const noModifyProject = {
            id: -1,
            shortName: this.$t(
              "wkt.admin.projects.calendar-wizard.no-modify-project"
            ),
          };
          const removeProject = {
            id: -2,
            shortName: this.$t(
              "wkt.admin.projects.calendar-wizard.remove-project"
            ),
          };
          this.projects.unshift(noModifyProject, removeProject);
        },
        (error) => {
          this.loading = false;
          this.doShowAlert({
            text: error.message,
            color: "error",
            timeout: 3000,
          });
        }
      );
    },
    doShowAlert(payload) {
      this.alertText = payload.text;
      this.alertColor = payload.color;
      this.alertTimeout = payload.timeout;
      this.showAlert = true;
    },
    convertToDateFormat(dateString) {
      const date = new Date(dateString);
      return {
        day: date.getDate(),
        month: date.getMonth() + 1,
        year: date.getFullYear(),
      };
    },
    onUpdate() {
      if (!this.validate()) {
        return;
      }

      if (this.vacationRecordType != 7 /*Constants.VACATION_RECORD_TYPE_COMPLETE_DAY*/ &&
          this.vacationRecordType != 8 /*Constants.VACATION_RECORD_TYPE_FOR_HOURS*/
      ){
        this.conflicts=[];
        this.showConfirm=true;
        return;
      }

      const data = this.getAssistantData();
      this.loading = true;
      api.validateVacationAssistant(data, (res) => {
        this.loading = false;
        this.conflicts=res;
        this.showConfirm=true;
      }, (error) => {
        this.loading = false;
        this.doShowAlert({
          text: error.message,
          color: "error",
          timeout: 3000,
        });
      });
    },
    getAssistantData() {
      const fromDate = this.convertToDateFormat(this.fromDateIso);
      const toDate = this.vacationRecordType === 7 ? this.convertToDateFormat(this.toDateIso) : null;
      const employeeIds = this.employees.map((e) => e.id);
      const data = {
        fromDate: fromDate,
        toDate: toDate,
        employeeIds: employeeIds,
        vacationDays: this.vacationDays,
        allowNegativeBalance: this.allowNegativeBalance,
        hoursBagId: this.selectedHourBag,
        description: this.vacationDescription,
        recordType: this.vacationRecordType,
      };
      return data;
    },
    processVacationAssistant() {
      this.loading = true;
      this.showConfirm=false;
      const data = this.getAssistantData();
      api.processVacationAssistant(
        data,
        (res) => {
          this.loading = false;
          if (res.resultCode == 100) {
            this.doShowAlert({
              text: this.$t("wkt.admin.common.task_in_background"),
              color: "success",
              timeout: 3000,
            });
            gwt.fireEvent("UpdateVacationCalendarEvent");
            this.showDialog = false;
            return;
          }

          if (res.resultCode == -100) {
            this.doShowAlert({
              text: this.$t("wkt.admin.common.task_in_progress_error"),
              color: "error",
              timeout: 3000,
            });
            return;
          }

          this.doShowAlert({
            text: this.$t(
              "wkt.admin.projects.calendar-wizard.update-message-ok"
            ),
            color: "success",
            timeout: 3000,
          });
          gwt.fireEvent("UpdateVacationCalendarEvent");
          this.showDialog = false;
        },
        (error) => {
          this.loading = false;
          this.showDialog = false;
          this.$log.error(error);
          this.doShowAlert({
            text: error.message,
            color: "error",
            timeout: 3000,
          });
        }
      );
    },
    close() {
      this.showDialog = false;
      this.fromDateFormatted = null;
      this.fromDateIso = null;
      this.toDateFormatted = null;
      this.toDateIso = null;
      this.employees = [];
      this.vacationDescription = "";
    },
    updateVacationDays() {
      if (this.fromDateIso && this.toDateIso && this.vacationRecordType == 7 /*Constants.VACATION_RECORD_TYPE_COMPLETE_DAY*/) {
        const dtStart = new Date(this.fromDateIso).getTime();
        const dtEnd = new Date(this.toDateIso).getTime();
        const diff = Math.round((dtStart- dtEnd) / (1000 * 60 * 60 * 24)) -1;
        this.vacationDays = dtEnd >= dtStart  ? diff : 0;
      }
    }
  },

  watch: {
    fromDateIso(val) {
      this.fromDateFormatted = this.formatOnlyDate(val);
      if (this.fromDateIso>this.toDateIso) {
        this.toDateIso = this.fromDateIso;
        this.toDateFormatted = this.fromDateFormatted;
      }
      this.updateVacationDays();
    },
    toDateIso(val) {
      this.toDateFormatted = this.formatOnlyDate(val);
      if (this.fromDateIso>this.toDateIso) {
        this.fromDateIso = this.toDateIso;
        this.fromDateFormatted = this.toDateFormatted;
      }
      this.updateVacationDays();
    }
  },
};  
</script> 